// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_user.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "stcs_cmw";

export enum NumberFormatEnum {
  NFO_ZERO = 0,
  NFO_TAUSEND = 1,
  NFO_MILLION = 2,
  UNRECOGNIZED = -1,
}

export function numberFormatEnumFromJSON(object: any): NumberFormatEnum {
  switch (object) {
    case 0:
    case "NFO_ZERO":
      return NumberFormatEnum.NFO_ZERO;
    case 1:
    case "NFO_TAUSEND":
      return NumberFormatEnum.NFO_TAUSEND;
    case 2:
    case "NFO_MILLION":
      return NumberFormatEnum.NFO_MILLION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NumberFormatEnum.UNRECOGNIZED;
  }
}

export function numberFormatEnumToJSON(object: NumberFormatEnum): string {
  switch (object) {
    case NumberFormatEnum.NFO_ZERO:
      return "NFO_ZERO";
    case NumberFormatEnum.NFO_TAUSEND:
      return "NFO_TAUSEND";
    case NumberFormatEnum.NFO_MILLION:
      return "NFO_MILLION";
    case NumberFormatEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DecimalPlacesEnum {
  D_ZERO = 0,
  D_ONE = 1,
  D_TWO = 2,
  UNRECOGNIZED = -1,
}

export function decimalPlacesEnumFromJSON(object: any): DecimalPlacesEnum {
  switch (object) {
    case 0:
    case "D_ZERO":
      return DecimalPlacesEnum.D_ZERO;
    case 1:
    case "D_ONE":
      return DecimalPlacesEnum.D_ONE;
    case 2:
    case "D_TWO":
      return DecimalPlacesEnum.D_TWO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DecimalPlacesEnum.UNRECOGNIZED;
  }
}

export function decimalPlacesEnumToJSON(object: DecimalPlacesEnum): string {
  switch (object) {
    case DecimalPlacesEnum.D_ZERO:
      return "D_ZERO";
    case DecimalPlacesEnum.D_ONE:
      return "D_ONE";
    case DecimalPlacesEnum.D_TWO:
      return "D_TWO";
    case DecimalPlacesEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DecimalSeparatorEnum {
  DS_POINT = 0,
  DS_COMMA = 1,
  UNRECOGNIZED = -1,
}

export function decimalSeparatorEnumFromJSON(object: any): DecimalSeparatorEnum {
  switch (object) {
    case 0:
    case "DS_POINT":
      return DecimalSeparatorEnum.DS_POINT;
    case 1:
    case "DS_COMMA":
      return DecimalSeparatorEnum.DS_COMMA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DecimalSeparatorEnum.UNRECOGNIZED;
  }
}

export function decimalSeparatorEnumToJSON(object: DecimalSeparatorEnum): string {
  switch (object) {
    case DecimalSeparatorEnum.DS_POINT:
      return "DS_POINT";
    case DecimalSeparatorEnum.DS_COMMA:
      return "DS_COMMA";
    case DecimalSeparatorEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum NegativeNumberFormatEnum {
  NNF_MINUS = 0,
  NNF_BRACKETS = 1,
  UNRECOGNIZED = -1,
}

export function negativeNumberFormatEnumFromJSON(object: any): NegativeNumberFormatEnum {
  switch (object) {
    case 0:
    case "NNF_MINUS":
      return NegativeNumberFormatEnum.NNF_MINUS;
    case 1:
    case "NNF_BRACKETS":
      return NegativeNumberFormatEnum.NNF_BRACKETS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NegativeNumberFormatEnum.UNRECOGNIZED;
  }
}

export function negativeNumberFormatEnumToJSON(object: NegativeNumberFormatEnum): string {
  switch (object) {
    case NegativeNumberFormatEnum.NNF_MINUS:
      return "NNF_MINUS";
    case NegativeNumberFormatEnum.NNF_BRACKETS:
      return "NNF_BRACKETS";
    case NegativeNumberFormatEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PercentageDecimalPlaces {
  PDP_ZERO = 0,
  PDP_ONE = 1,
  PDP_TWO = 2,
  UNRECOGNIZED = -1,
}

export function percentageDecimalPlacesFromJSON(object: any): PercentageDecimalPlaces {
  switch (object) {
    case 0:
    case "PDP_ZERO":
      return PercentageDecimalPlaces.PDP_ZERO;
    case 1:
    case "PDP_ONE":
      return PercentageDecimalPlaces.PDP_ONE;
    case 2:
    case "PDP_TWO":
      return PercentageDecimalPlaces.PDP_TWO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PercentageDecimalPlaces.UNRECOGNIZED;
  }
}

export function percentageDecimalPlacesToJSON(object: PercentageDecimalPlaces): string {
  switch (object) {
    case PercentageDecimalPlaces.PDP_ZERO:
      return "PDP_ZERO";
    case PercentageDecimalPlaces.PDP_ONE:
      return "PDP_ONE";
    case PercentageDecimalPlaces.PDP_TWO:
      return "PDP_TWO";
    case PercentageDecimalPlaces.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** v1.8.0 */
export interface StcsUser {
  id: string;
  euuid: string;
  version: string;
  meta: StcsUserMetaData | undefined;
  data: StcsUserData | undefined;
  settings: StcsUserSettings | undefined;
}

export interface StcsWappUser {
  id: string;
  euuid: string;
  version: string;
  meta: StcsUserMetaData | undefined;
  data: StcsUserData | undefined;
  settings: StcsUserSettings | undefined;
}

export interface StcsUserMetaData {
  last_active_iso_utc: string;
  last_sign_in_iso_utc: string;
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
  ref_id_user_invite?: string | undefined;
}

export interface StcsUserData {
  email: string;
  name_display: string;
  name_first: string;
  name_last: string;
  acc_state: string;
  acc_active: boolean;
  title: string;
  user_picture_url: string;
}

/** 2.0.0 */
export interface StcsUserSettings {
  sel_lang: string;
  sel_theme: string;
  newsletter_subscribed: boolean;
}

export interface NumberFormatOptions {
  number_format: NumberFormatEnum;
  decimal_places: DecimalPlacesEnum;
  decimal_separator: DecimalSeparatorEnum;
  negative_number_format: NegativeNumberFormatEnum;
  percentage_decimal_places: PercentageDecimalPlaces;
}

function createBaseStcsUser(): StcsUser {
  return { id: "", euuid: "", version: "", meta: undefined, data: undefined, settings: undefined };
}

export const StcsUser: MessageFns<StcsUser> = {
  encode(message: StcsUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.euuid !== "") {
      writer.uint32(18).string(message.euuid);
    }
    if (message.version !== "") {
      writer.uint32(34).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsUserMetaData.encode(message.meta, writer.uint32(42).fork()).join();
    }
    if (message.data !== undefined) {
      StcsUserData.encode(message.data, writer.uint32(50).fork()).join();
    }
    if (message.settings !== undefined) {
      StcsUserSettings.encode(message.settings, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.euuid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.meta = StcsUserMetaData.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.data = StcsUserData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.settings = StcsUserSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsUser {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      euuid: isSet(object.euuid) ? globalThis.String(object.euuid) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsUserMetaData.fromJSON(object.meta) : undefined,
      data: isSet(object.data) ? StcsUserData.fromJSON(object.data) : undefined,
      settings: isSet(object.settings) ? StcsUserSettings.fromJSON(object.settings) : undefined,
    };
  },

  toJSON(message: StcsUser): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.euuid !== "") {
      obj.euuid = message.euuid;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsUserMetaData.toJSON(message.meta);
    }
    if (message.data !== undefined) {
      obj.data = StcsUserData.toJSON(message.data);
    }
    if (message.settings !== undefined) {
      obj.settings = StcsUserSettings.toJSON(message.settings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsUser>, I>>(base?: I): StcsUser {
    return StcsUser.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsUser>, I>>(object: I): StcsUser {
    const message = createBaseStcsUser();
    message.id = object.id ?? "";
    message.euuid = object.euuid ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsUserMetaData.fromPartial(object.meta)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? StcsUserData.fromPartial(object.data)
      : undefined;
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? StcsUserSettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseStcsWappUser(): StcsWappUser {
  return { id: "", euuid: "", version: "", meta: undefined, data: undefined, settings: undefined };
}

export const StcsWappUser: MessageFns<StcsWappUser> = {
  encode(message: StcsWappUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.euuid !== "") {
      writer.uint32(18).string(message.euuid);
    }
    if (message.version !== "") {
      writer.uint32(34).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsUserMetaData.encode(message.meta, writer.uint32(42).fork()).join();
    }
    if (message.data !== undefined) {
      StcsUserData.encode(message.data, writer.uint32(50).fork()).join();
    }
    if (message.settings !== undefined) {
      StcsUserSettings.encode(message.settings, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsWappUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsWappUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.euuid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.meta = StcsUserMetaData.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.data = StcsUserData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.settings = StcsUserSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsWappUser {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      euuid: isSet(object.euuid) ? globalThis.String(object.euuid) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsUserMetaData.fromJSON(object.meta) : undefined,
      data: isSet(object.data) ? StcsUserData.fromJSON(object.data) : undefined,
      settings: isSet(object.settings) ? StcsUserSettings.fromJSON(object.settings) : undefined,
    };
  },

  toJSON(message: StcsWappUser): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.euuid !== "") {
      obj.euuid = message.euuid;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsUserMetaData.toJSON(message.meta);
    }
    if (message.data !== undefined) {
      obj.data = StcsUserData.toJSON(message.data);
    }
    if (message.settings !== undefined) {
      obj.settings = StcsUserSettings.toJSON(message.settings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsWappUser>, I>>(base?: I): StcsWappUser {
    return StcsWappUser.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsWappUser>, I>>(object: I): StcsWappUser {
    const message = createBaseStcsWappUser();
    message.id = object.id ?? "";
    message.euuid = object.euuid ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsUserMetaData.fromPartial(object.meta)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? StcsUserData.fromPartial(object.data)
      : undefined;
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? StcsUserSettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseStcsUserMetaData(): StcsUserMetaData {
  return {
    last_active_iso_utc: "",
    last_sign_in_iso_utc: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
    ref_id_user_invite: undefined,
  };
}

export const StcsUserMetaData: MessageFns<StcsUserMetaData> = {
  encode(message: StcsUserMetaData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.last_active_iso_utc !== "") {
      writer.uint32(10).string(message.last_active_iso_utc);
    }
    if (message.last_sign_in_iso_utc !== "") {
      writer.uint32(18).string(message.last_sign_in_iso_utc);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(26).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(34).string(message.obj_updated_iso_utc);
    }
    if (message.ref_id_user_invite !== undefined) {
      writer.uint32(42).string(message.ref_id_user_invite);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsUserMetaData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsUserMetaData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.last_active_iso_utc = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.last_sign_in_iso_utc = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ref_id_user_invite = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsUserMetaData {
    return {
      last_active_iso_utc: isSet(object.last_active_iso_utc) ? globalThis.String(object.last_active_iso_utc) : "",
      last_sign_in_iso_utc: isSet(object.last_sign_in_iso_utc) ? globalThis.String(object.last_sign_in_iso_utc) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      ref_id_user_invite: isSet(object.ref_id_user_invite) ? globalThis.String(object.ref_id_user_invite) : undefined,
    };
  },

  toJSON(message: StcsUserMetaData): unknown {
    const obj: any = {};
    if (message.last_active_iso_utc !== "") {
      obj.last_active_iso_utc = message.last_active_iso_utc;
    }
    if (message.last_sign_in_iso_utc !== "") {
      obj.last_sign_in_iso_utc = message.last_sign_in_iso_utc;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.ref_id_user_invite !== undefined) {
      obj.ref_id_user_invite = message.ref_id_user_invite;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsUserMetaData>, I>>(base?: I): StcsUserMetaData {
    return StcsUserMetaData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsUserMetaData>, I>>(object: I): StcsUserMetaData {
    const message = createBaseStcsUserMetaData();
    message.last_active_iso_utc = object.last_active_iso_utc ?? "";
    message.last_sign_in_iso_utc = object.last_sign_in_iso_utc ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.ref_id_user_invite = object.ref_id_user_invite ?? undefined;
    return message;
  },
};

function createBaseStcsUserData(): StcsUserData {
  return {
    email: "",
    name_display: "",
    name_first: "",
    name_last: "",
    acc_state: "",
    acc_active: false,
    title: "",
    user_picture_url: "",
  };
}

export const StcsUserData: MessageFns<StcsUserData> = {
  encode(message: StcsUserData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.name_display !== "") {
      writer.uint32(18).string(message.name_display);
    }
    if (message.name_first !== "") {
      writer.uint32(26).string(message.name_first);
    }
    if (message.name_last !== "") {
      writer.uint32(34).string(message.name_last);
    }
    if (message.acc_state !== "") {
      writer.uint32(42).string(message.acc_state);
    }
    if (message.acc_active !== false) {
      writer.uint32(48).bool(message.acc_active);
    }
    if (message.title !== "") {
      writer.uint32(58).string(message.title);
    }
    if (message.user_picture_url !== "") {
      writer.uint32(66).string(message.user_picture_url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsUserData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsUserData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name_display = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name_first = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name_last = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.acc_state = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.acc_active = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.user_picture_url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsUserData {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      name_display: isSet(object.name_display) ? globalThis.String(object.name_display) : "",
      name_first: isSet(object.name_first) ? globalThis.String(object.name_first) : "",
      name_last: isSet(object.name_last) ? globalThis.String(object.name_last) : "",
      acc_state: isSet(object.acc_state) ? globalThis.String(object.acc_state) : "",
      acc_active: isSet(object.acc_active) ? globalThis.Boolean(object.acc_active) : false,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      user_picture_url: isSet(object.user_picture_url) ? globalThis.String(object.user_picture_url) : "",
    };
  },

  toJSON(message: StcsUserData): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.name_display !== "") {
      obj.name_display = message.name_display;
    }
    if (message.name_first !== "") {
      obj.name_first = message.name_first;
    }
    if (message.name_last !== "") {
      obj.name_last = message.name_last;
    }
    if (message.acc_state !== "") {
      obj.acc_state = message.acc_state;
    }
    if (message.acc_active !== false) {
      obj.acc_active = message.acc_active;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.user_picture_url !== "") {
      obj.user_picture_url = message.user_picture_url;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsUserData>, I>>(base?: I): StcsUserData {
    return StcsUserData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsUserData>, I>>(object: I): StcsUserData {
    const message = createBaseStcsUserData();
    message.email = object.email ?? "";
    message.name_display = object.name_display ?? "";
    message.name_first = object.name_first ?? "";
    message.name_last = object.name_last ?? "";
    message.acc_state = object.acc_state ?? "";
    message.acc_active = object.acc_active ?? false;
    message.title = object.title ?? "";
    message.user_picture_url = object.user_picture_url ?? "";
    return message;
  },
};

function createBaseStcsUserSettings(): StcsUserSettings {
  return { sel_lang: "", sel_theme: "", newsletter_subscribed: false };
}

export const StcsUserSettings: MessageFns<StcsUserSettings> = {
  encode(message: StcsUserSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sel_lang !== "") {
      writer.uint32(10).string(message.sel_lang);
    }
    if (message.sel_theme !== "") {
      writer.uint32(26).string(message.sel_theme);
    }
    if (message.newsletter_subscribed !== false) {
      writer.uint32(48).bool(message.newsletter_subscribed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsUserSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsUserSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sel_lang = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sel_theme = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.newsletter_subscribed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsUserSettings {
    return {
      sel_lang: isSet(object.sel_lang) ? globalThis.String(object.sel_lang) : "",
      sel_theme: isSet(object.sel_theme) ? globalThis.String(object.sel_theme) : "",
      newsletter_subscribed: isSet(object.newsletter_subscribed)
        ? globalThis.Boolean(object.newsletter_subscribed)
        : false,
    };
  },

  toJSON(message: StcsUserSettings): unknown {
    const obj: any = {};
    if (message.sel_lang !== "") {
      obj.sel_lang = message.sel_lang;
    }
    if (message.sel_theme !== "") {
      obj.sel_theme = message.sel_theme;
    }
    if (message.newsletter_subscribed !== false) {
      obj.newsletter_subscribed = message.newsletter_subscribed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsUserSettings>, I>>(base?: I): StcsUserSettings {
    return StcsUserSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsUserSettings>, I>>(object: I): StcsUserSettings {
    const message = createBaseStcsUserSettings();
    message.sel_lang = object.sel_lang ?? "";
    message.sel_theme = object.sel_theme ?? "";
    message.newsletter_subscribed = object.newsletter_subscribed ?? false;
    return message;
  },
};

function createBaseNumberFormatOptions(): NumberFormatOptions {
  return {
    number_format: 0,
    decimal_places: 0,
    decimal_separator: 0,
    negative_number_format: 0,
    percentage_decimal_places: 0,
  };
}

export const NumberFormatOptions: MessageFns<NumberFormatOptions> = {
  encode(message: NumberFormatOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.number_format !== 0) {
      writer.uint32(8).int32(message.number_format);
    }
    if (message.decimal_places !== 0) {
      writer.uint32(16).int32(message.decimal_places);
    }
    if (message.decimal_separator !== 0) {
      writer.uint32(24).int32(message.decimal_separator);
    }
    if (message.negative_number_format !== 0) {
      writer.uint32(32).int32(message.negative_number_format);
    }
    if (message.percentage_decimal_places !== 0) {
      writer.uint32(40).int32(message.percentage_decimal_places);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NumberFormatOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNumberFormatOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.number_format = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.decimal_places = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.decimal_separator = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.negative_number_format = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.percentage_decimal_places = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NumberFormatOptions {
    return {
      number_format: isSet(object.number_format) ? numberFormatEnumFromJSON(object.number_format) : 0,
      decimal_places: isSet(object.decimal_places) ? decimalPlacesEnumFromJSON(object.decimal_places) : 0,
      decimal_separator: isSet(object.decimal_separator) ? decimalSeparatorEnumFromJSON(object.decimal_separator) : 0,
      negative_number_format: isSet(object.negative_number_format)
        ? negativeNumberFormatEnumFromJSON(object.negative_number_format)
        : 0,
      percentage_decimal_places: isSet(object.percentage_decimal_places)
        ? percentageDecimalPlacesFromJSON(object.percentage_decimal_places)
        : 0,
    };
  },

  toJSON(message: NumberFormatOptions): unknown {
    const obj: any = {};
    if (message.number_format !== 0) {
      obj.number_format = numberFormatEnumToJSON(message.number_format);
    }
    if (message.decimal_places !== 0) {
      obj.decimal_places = decimalPlacesEnumToJSON(message.decimal_places);
    }
    if (message.decimal_separator !== 0) {
      obj.decimal_separator = decimalSeparatorEnumToJSON(message.decimal_separator);
    }
    if (message.negative_number_format !== 0) {
      obj.negative_number_format = negativeNumberFormatEnumToJSON(message.negative_number_format);
    }
    if (message.percentage_decimal_places !== 0) {
      obj.percentage_decimal_places = percentageDecimalPlacesToJSON(message.percentage_decimal_places);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NumberFormatOptions>, I>>(base?: I): NumberFormatOptions {
    return NumberFormatOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NumberFormatOptions>, I>>(object: I): NumberFormatOptions {
    const message = createBaseNumberFormatOptions();
    message.number_format = object.number_format ?? 0;
    message.decimal_places = object.decimal_places ?? 0;
    message.decimal_separator = object.decimal_separator ?? 0;
    message.negative_number_format = object.negative_number_format ?? 0;
    message.percentage_decimal_places = object.percentage_decimal_places ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
